/**
 * Convert price
 *
 * @param {string|number} price Price
 * @returns {float} value Price with decimals, e.g. 123.45
 */
export default function convertPrice(price: number | string = 0): number {
    return parseFloat(parseFloat(String(price)).toFixed(2));
}

/**
 * Convert price for EEC reports
 *
 * @param {string|number} price Price
 * @returns {string} price with 4 decimals in string format, e.g. '123.4578'
 */
export function convertPriceEEC(price: number | string = ''): string {
    if (price === '') return '';
    return parseFloat(String(price)).toFixed(4);
}
